import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import moment from "moment";
import ComponentToPrintRetro from "./ComponentToPrintRetro";

const PrintReport = ({
  dataTable,
  setOpenModal, 
  reportHeader,
  TimeSheetummary
}) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    // pageStyle: `
    // @page {
    //   @bottom-left {
    //     content: counter(page) ' of ' counter(pages);
    //   }
    // }

    // `
    // onAfterPrint: () => {
    //   setIsLoading(false)
    // },
    onAfterPrint: () => {
      // setShowSR(false);
    },
    documentTitle: `Report_Employee-${moment().format("MM-DD-YY-HH:mm:ss")}`,
  });

  useEffect(() => {
    setOpenModal(false);
    handlePrint();
  }, []);
  return (
    <div>
      <ComponentToPrintRetro
        ref={componentRef}
        dataTable={dataTable}
        reportHeader={reportHeader}
        TimeSheetummary={TimeSheetummary}
        
      />
      {/* <button onClick={handlePrint}>Print this out!</button> */}
    </div>
  );
};

export default PrintReport;
